import Component from '../Component';
import * as uiStrings from '../../uiStrings';
import quizManager from '../../managers/QuizManager';
import Block from './Block';
import childrenLokalityData from './childrenData/lokality';
import childrenNareciData from './childrenData/nareci';
import childrenAdminData from './childrenData/admin';
import SearchButton from '../ControlButtonGroup/SearchButton';
import * as eventNames from '../../customEventStrings';
import CircularProgressBar from "circular-progress-bar";


class Layers extends Component {
	constructor(props) {
		super(props);

		this.lokalityBlock = new Block({
			blockClassName: 'js-layers-filterable',
			headingText: 'Vyber kvíz',
			controlClassName: 'js-layers-markers',
		});

		this.progressBar = null;

	}

	componentDidMount() {
		this.lokalityBlock.setRefs(this.refs);
		this.lokalityBlock.componentDidMount();

		//circular progress bar to display final score (evaluation part)
		const options = {
			size: 150,
			background: "transparent", 
			colors: ["#80e1ff"], //bledomodra nech to ladi so satkou v logu
		};
		this.progressBar = new CircularProgressBar(0, options);
		this.progressBar.appendTo(this.refs['quiz-evaluate-progressbar']);

		this.setupEventListeners();

		this.refs['start-quiz-button-wrapper'].classList.toggle('u-hidden'); //start kviz nech je viditelny
		this.refs['quiz-type-section'].classList.toggle('u-hidden'); //typ kvizu picker nech je viditelny

	}

	setupEventListeners() {
		const startQuizButton = this.refs['start-quiz-button'];
		const evaluateQuizButton = this.refs['evaluate-quiz-button'];
		const evaluateAnotherQuizButton = this.refs['start-another-quiz-button'];

		startQuizButton.addEventListener("click", () => {
			var selectedQuizType = this.getSelectedQuizType();
			quizManager.setQuizType(selectedQuizType);
			//exampleIds su tu uz naplnene z Markers
			quizManager.start();
			document.getElementById("quiz-progress").value = quizManager.getProgress(); // + " %"; 
//			startQuizButton.setAttribute('disabled', true);  //je sice disablovany, neda sa klikat, ale vyzera ako normalny :(
			// pouzivam classList.add a remove namiesto toggle - viac explicitne, je jasne aky vysledok chcem dosiahnut
		    this.refs['start-quiz-button-wrapper'].classList.add('u-hidden'); //start button neviditelny po stlaceni
			this.refs['evaluate-quiz-button-wrapper'].classList.add('u-hidden'); //evaluate button neviditelny 
			//DEBUG!! this.refs['evaluate-quiz-button-wrapper'].classList.remove('u-hidden'); //evaluate button viditelny //DEBUG ONLY!!

			this.refs['quiz-progress-section'].classList.remove('u-hidden'); //progres viditelny
			this.refs['quiz-evaluate-section'].classList.add('u-hidden'); //kviz evaluate neviditelny
			this.refs['quiz-type-section'].classList.add('u-hidden'); //typ kvizu picker neviditelny

			// na mobile skryjeme panel, nech uzivatel vidi mapu
			if (document.documentElement.clientWidth <= 970) {
				const panel = this.refs['content-layers'].closest('.layerPanel');
				if (panel) { panel.classList.remove('active'); }
			}
    	});

		evaluateQuizButton.addEventListener("click", (e) => {
			//tento buton je viditelny len ak quizManager.isAllAnswers() - t.j. mame odpovede na vsetky otazky, mozeme vyhodnotit kviz
			// vid setupEventListeners v QuizAnswer.js, tam sa kontroluje ci mame vsetky odpovede a az potom sa tento buton robi viditelny
			quizManager.finish();
			this.progressBar.value = 0; //reset progress baru pro plynuly prechod k vysledku
			this.progressBar.transitionTime = 3000;
			this.progressBar.value = quizManager.getResultPercentage();
			this.refs['quiz-evaluate-text'].innerHTML = `<p style="color: #ffffff; font-size: 1.5rem;">${quizManager.getResultText()}</p>`;
			var evaluateTable = quizManager.getEvaluateTable();
			this.refs['quiz-evaluate-table'].innerHTML = evaluateTable;

			this.refs['evaluate-quiz-button-wrapper'].classList.add('u-hidden'); //evaluate button neviditelny po kliku
			this.refs['quiz-progress-section'].classList.add('u-hidden'); //progres neviditelny
			this.refs['quiz-evaluate-section'].classList.remove('u-hidden'); //kviz evaluate viditelny
			this.dispatchCustomEvent(eventNames.CHANGE_QUIZ_MARKER_STATE, e.target); //refresh markers on map - evaluated answer markers
    	});

		evaluateAnotherQuizButton.addEventListener("click", (e) => {
			quizManager.reset(); 
			this.refs['quiz-progress-section'].classList.add('u-hidden'); //progres neviditelny
			this.refs['quiz-evaluate-section'].classList.add('u-hidden'); //kviz evaluate neviditelny
			this.refs['quiz-type-section'].classList.remove('u-hidden'); //typ kvizu picker viditelny
		    this.refs['start-quiz-button-wrapper'].classList.remove('u-hidden'); // start button zase viditelny
			this.dispatchCustomEvent(eventNames.CHANGE_QUIZ_MARKER_STATE, e.target); //refresh markers on map - back to base state, question icons
		});


	}

	
	getSelectedQuizType() {
		var radioButtons = document.getElementsByName("quizes");
		for (var i = 0; i < radioButtons.length; i++) {
			if (radioButtons[i].checked) {
				return radioButtons[i].value; //-->
			}
		}
		return -1; 
	}
	

	toggleActive() {
		this.refs['content-layers'].classList.toggle('active');
	}

	render() {
        //bolo class="layerPanel__content--layers active scroll"
		return (`
            <div ref="content-layers" class="layerPanel__content--filters active scroll">
				<div ref="quiz-type-section" class="layerPanel__block js-layers-filterable u-hidden" style="margin-top:1em;">
	                ${this.lokalityBlock.setChildren(childrenLokalityData).render()}
				</div>
				<div ref="start-quiz-button-wrapper" style="margin-top:3em;" class="u-hidden">
				  <button type="button" ref="start-quiz-button" class="btn btn--primary" style="font-size:2rem;"><i class="fas"></i> Začni kvíz ! </button>
				</div>
				<div ref="quiz-progress-section" class="layerPanel__block js-layers-filterable u-hidden" style="margin-top:1em;">
                	<div><span class="layerPanel__heading">Vyplnené odpovede v kvíze</span></div>
					<input type="text" id="quiz-progress" value="" 
					  style="font-size:3rem; background-color:rgba(0, 0, 0, 0); color:white; border: none; outline:none; width:50%; max-width:50%;" 
					  readonly 
					/>
				</div>
				<div ref="evaluate-quiz-button-wrapper" style="margin-top:3em;" class="u-hidden">
				  <button type="button" ref="evaluate-quiz-button" id="evaluate-quiz-button" class="btn btn--primary" style="font-size:2rem;"><i class="fas"></i> Vyhodnoť kvíz </button>
				</div>
				<div ref="quiz-evaluate-section" class="layerPanel__block js-layers-filterable u-hidden" style="margin-top:0;">
                	<div><span class="layerPanel__heading">Vyhodnotenie kvízu</span></div>
					<div ref="quiz-evaluate-progressbar" style="margin-top:1em;"> </div> 
					<div ref="quiz-evaluate-text" style="margin-top:1em;"></div>
					<div ref="quiz-evaluate-table" style="margin-top:3em; overflow-x:auto; max-width:100%;"></div>
					<div style="margin-top:3em;">
						<button type="button" ref="start-another-quiz-button" class="btn btn--primary" style="font-size:2rem;"><i class="fas"></i> Začni ďalší kvíz ! </button>
					</div>
				</div>				

            </div>`
/*
					<input type="text" id="quiz-evaluate" 
					  style="font-size:4rem; background-color:rgba(0, 0, 0, 0); color:white; border: none; outline:none; width:50%; max-width:50%;" value="" 
					  readonly 
					/>
*/
			);
	}
}

export default Layers;
